import React, { useState } from "react";
import PatientTypeForm from '../patienttype-form/PatientTypeForm';
import APIResponse from "../../../../templates/components/APIResponse";
import DimLoader from "../../../../templates/components/DimLoader";
import PatientTypeService from "../../../../../services/api/patient-type.service";
const AddPatientType = (props) => {
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse, setApiResponse] = useState()
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const submitHandler = (data) => {
        setIsLoader(true)
        let reqObj = { ...data }
        console.log("data", data)
        PatientTypeService.addPatientType(reqObj)
            .then(response => {
                setApiResponse(response)
                setIsLoader(false)
            })
            .catch(error => {
                setApiResponse(error)
                setIsLoader(false)
            })
    }
    return <>
        {isLoader &&
            <DimLoader loadMessage="Processing" />
        }
        <PatientTypeForm submitHandler={submitHandler} onClose={() => props.onClose()} />
        <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
    </>
}

export default AddPatientType;